module.exports = __webpack_public_path__ + "static/media/logo-180x180.b877f791.png";